import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Building2, X, Sidebar, LogOut } from 'lucide-react'

const VendorSidebar = ({
  sidebarOpen,
  onToggle,
  sidebarItems,
  onLogout
}) => {
  const location = useLocation()
  
  const getActiveTab = () => {
    const path = location.pathname
    if (path.includes('/bench-resources')) return 'bench-resources'
    if (path.includes('/purchase-orders')) return 'purchase-orders'
    if (path.includes('/interviews')) return 'interviews'
    if (path.includes('/placements')) return 'placements'
    if (path.includes('/subscription')) return 'subscription'
    if (path.includes('/payments')) return 'payments'
    if (path.includes('/settings')) return 'settings'
    return 'overview'
  }
  
  const activeTab = getActiveTab()
  
  const getRoutePath = (id) => {
    const basePath = '/vendor/dashboard'
    if (id === 'overview') return basePath
    return `${basePath}/${id}`
  }
  return (
    <div className={`${sidebarOpen ? 'w-64' : 'w-16'} fixed left-0 top-0 h-screen transition-all duration-300 bg-white dark:bg-secondary-800 shadow-lg border-r border-secondary-200 dark:border-secondary-700 z-40 overflow-hidden flex flex-col`}>
      <div className="p-4 flex-shrink-0">
        <div className="flex items-center justify-between mb-6">
          {sidebarOpen && (
            <div className="flex items-center">
              <Building2 className="w-8 h-8 text-primary-600 mr-3" />
              <div>
                <h1 className="text-lg font-bold text-secondary-900 dark:text-secondary-100">AJA Bench</h1>
                <p className="text-xs text-secondary-600 dark:text-secondary-400">Vendor Portal</p>
              </div>
            </div>
          )}
          <button
            onClick={onToggle}
            className={`${sidebarOpen ? 'p-2' : 'p-3'} text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors`}
            title={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
          >
            {sidebarOpen ? <X className="w-5 h-5" /> : <Sidebar className="w-6 h-6" />}
          </button>
        </div>

        <nav className="space-y-2 overflow-y-auto flex-1">
          {sidebarItems.map((item) => (
            <Link
              key={item.id}
              to={getRoutePath(item.id)}
              className={`w-full flex items-center ${sidebarOpen ? 'px-3 py-2.5' : 'px-2 py-3 justify-center'} rounded-lg text-left transition-all duration-200 ${
                activeTab === item.id
                  ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 shadow-sm'
                  : 'text-secondary-700 dark:text-secondary-300 hover:bg-secondary-100 dark:hover:bg-secondary-700'
              }`}
            >
              <div className={sidebarOpen ? '' : 'w-6 h-6 flex items-center justify-center'}>
                {sidebarOpen ? item.icon : React.cloneElement(item.icon, { className: 'w-6 h-6' })}
              </div>
              {sidebarOpen && (
                <>
                  <span className="ml-3">{item.name}</span>
                  {item.badge && (
                    <span className={`ml-auto px-2 py-1 text-xs rounded-full ${
                      typeof item.badge === 'number'
                        ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300'
                        : 'bg-success-100 dark:bg-success-900/30 text-success-700 dark:text-success-300'
                    }`}>
                      {item.badge}
                    </span>
                  )}
                </>
              )}
            </Link>
          ))}
          
          {/* Logout Button */}
          <button
            onClick={onLogout}
            className={`w-full flex items-center ${sidebarOpen ? 'px-3 py-2' : 'px-2 py-3 justify-center'} rounded-lg text-left transition-colors text-error-700 dark:text-error-300 hover:bg-error-50 dark:hover:bg-error-900/20`}
          >
            <div className={sidebarOpen ? '' : 'w-6 h-6 flex items-center justify-center'}>
              {sidebarOpen ? <LogOut className="w-5 h-5" /> : <LogOut className="w-6 h-6" />}
            </div>
            {sidebarOpen && (
              <span className="ml-3">Logout</span>
            )}
          </button>
        </nav>
      </div>
    </div>
  )
}

export default VendorSidebar

